import { Federation } from "../federation/federation";
import { ClubRessource } from "../resource/resource";

export class ClubDetails {
    clubKey?: number;
    clubCode: string;
    clubName: string;
    postalCode?: string;
    city?: string;
    address?: string;
    addressNumber?: string;
    box?: string;
    mail?: string;
    logo?: string;
    logoBase64?: string;
    contactPerson?: string;
    smsPhoneNumber?: string;
    phoneNumber?: string;
    limitPriorities?: number;
    priorities?: number;
    federation?: Federation[];
    federationKeys?: string;

    static fromObject(object: ClubDetails): ClubDetails {
      return Object.assign(new ClubDetails(), {
        ...object,
        federation: object.federation?.map(fede => Federation.fromObject(fede)) || []
      });
  }
}

export class CodeClub {
    code: string;
    name: string;
}


export class SessionByClub {
    sessionKey: number;
    dateLib: string;
    sessionStartDate: string;
    sessionEndDate: string;
    quantity: number;
    isActive: boolean;
    offerName: string;
    image: string;
    ressources: ClubRessource[];
    trainees: any[];
    offerKey?: string;
}

export class LegalNotice {
  clubCode?: string;
  legalNoticeInvoice: string;
  legalNoticeQuote: string;
}
